<template>
  <v-container fluid grid-list-md py1 class="seOOB mb-8">
    <v-layout row wrap>
      <v-flex xs12>
        <data-table ref="seOOBTable" @editRow="load" @auditRow="audit" />
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex xs12>
        <v-card>
          <v-card-title primary-title class="py-2">
            <v-toolbar-title>{{ $t("view.operativos.seOOB.title") }}</v-toolbar-title>
            <v-spacer />
            <v-btn icon @click="view.elem.showForm = !view.elem.showForm">
              <v-icon>{{ view.elem.showForm ? "keyboard_arrow_down" : "keyboard_arrow_up" }}</v-icon>
            </v-btn>
          </v-card-title>
          <v-expand-transition>
            <v-flex v-show="view.elem.showForm" class="py-0">
              <v-card-text>
                <form onSubmit="return false;" @submit="submit" @keyup.ctrl.83="executeValidators">
                  <v-layout row wrap>
                    <!-- Nombre -->
                    <v-flex xs12 md4>
                      <v-text-field
                        v-model.trim="$v.seOOB.nombre.$model"
                        :label="$t('view.operativos.seOOB.form.nombre.label')"
                        :error-messages="getFirstErrorDescription($v.seOOB.nombre)"
                        maxlength="150"
                        :disabled="view.action.submit.busy" />
                    </v-flex>

                    <!-- nombrePersonaContacto -->
                    <v-flex xs12 md4>
                      <v-text-field
                        v-model.trim="$v.seOOB.nombrePersonaContacto.$model"
                        :label="$t('view.operativos.seOOB.form.nombrePersonaContacto.label')"
                        :error-messages="getFirstErrorDescription($v.seOOB.nombrePersonaContacto)"
                        maxlength="150"
                        :disabled="view.action.submit.busy" />
                    </v-flex>

                    <!-- Cuit -->
                    <v-flex xs12 md4>
                      <v-text-field
                        :key="refreshkey"
                        v-model.trim="$v.seOOB.cuit.$model"
                        v-mask="'##-########-#'"
                        :label="$t('view.operativos.seOOB.form.cuit.label')"
                        :error-messages="getFirstErrorDescription($v.seOOB.cuit)"
                        :disabled="view.action.submit.busy" />
                    </v-flex>

                    <!-- Dereccion -->
                    <v-flex xs12 md4>
                      <v-text-field
                        v-model.trim="$v.seOOB.direccion.$model"
                        :label="$t('view.operativos.seOOB.form.direccion.label')"
                        :error-messages="getFirstErrorDescription($v.seOOB.direccion)"
                        maxlength="150"
                        :disabled="view.action.submit.busy" />
                    </v-flex>

                    <v-flex xs12 md4>
                      <v-layout row wrap>
                        <!-- Altura -->
                        <v-flex xs6>
                          <v-text-field
                            v-model.trim="$v.seOOB.altura.$model"
                            :label="$t('view.operativos.seOOB.form.altura.label')"
                            :error-messages="getFirstErrorDescription($v.seOOB.altura)"
                            maxlength="5"
                            :disabled="view.action.submit.busy" />
                        </v-flex>

                        <!-- Codigo Postal -->
                        <v-flex xs6>
                          <v-text-field
                            v-model.trim="$v.seOOB.cp.$model"
                            :label="$t('view.operativos.seOOB.form.cp.label')"
                            :error-messages="getFirstErrorDescription($v.seOOB.cp)"
                            maxlength="10"
                            :disabled="view.action.submit.busy"
                            onkeypress="return /^[0-9.0-9]*$/.test(event.key);"
                            @change="clearLocalization" />
                        </v-flex>
                      </v-layout>
                    </v-flex>

                    <!-- Provincia -->
                    <v-flex xs12 md4>
                      <v-autocomplete
                        v-model.trim="$v.seOOB.provincia.$model"
                        :search-input.sync="view.elem.select.provincia.search"
                        :label="$t('view.operativos.seOOB.form.provincia.label')"
                        :error-messages="getFirstErrorDescription($v.seOOB.provincia)"
                        :items="view.elem.select.provincia.filteredList"
                        :disabled="view.action.submit.busy"
                        item-value="code"
                        item-text="name"
                        hide-selected
                        hide-no-data
                        clearable
                        :no-data-text="$t('view.commons.nodata')"
                        @input="view.elem.select.provincia.search = ''"
                        @change="
                          form.$state.loadSelectLocalidad();
                          clearLocalization();
                        " />
                    </v-flex>

                    <!-- Localidad -->
                    <v-flex xs12 md4>
                      <v-autocomplete
                        v-model.trim="$v.seOOB.localidad.$model"
                        :search-input.sync="view.elem.select.localidad.search"
                        :label="$t('view.operativos.seOOB.form.localidad.label')"
                        :error-messages="getFirstErrorDescription($v.seOOB.localidad)"
                        :items="view.elem.select.localidad.filteredList"
                        :disabled="view.action.submit.busy"
                        item-value="code"
                        item-text="name"
                        hide-selected
                        hide-no-data
                        clearable
                        :no-data-text="$t('view.commons.nodata')"
                        @input="view.elem.select.localidad.search = ''"
                        @change="clearLocalization" />
                    </v-flex>

                    <!-- Referencia -->
                    <v-flex xs12 md4>
                      <v-text-field
                        v-model.trim="$v.seOOB.referencia.$model"
                        :label="$t('view.operativos.seOOB.form.referencia.label')"
                        :error-messages="getFirstErrorDescription($v.seOOB.referencia)"
                        maxlength="100"
                        :disabled="view.action.submit.busy" />
                    </v-flex>

                    <!-- Email -->
                    <v-flex xs12 md4>
                      <v-text-field
                        v-model="$v.seOOB.email.$model"
                        :label="$t('view.operativos.seOOB.form.email.label')"
                        :error-messages="getFirstErrorDescription($v.seOOB.email)"
                        maxlength="80"
                        :disabled="view.action.submit.busy" />
                    </v-flex>

                    <!-- Telefono -->
                    <v-flex xs12 md4>
                      <v-text-field
                        v-model.trim="$v.seOOB.telefono.$model"
                        :label="$t('view.operativos.seOOB.form.telefono.label')"
                        :error-messages="getFirstErrorDescription($v.seOOB.telefono)"
                        maxlength="15"
                        :disabled="view.action.submit.busy"
                        onkeypress="return /^[0-9.0-9]*$/.test(event.key);" />
                    </v-flex>

                    <!-- Latitud -->
                    <v-flex xs12 md4>
                      <v-text-field
                        v-model.trim="$v.seOOB.latitud.$model"
                        :label="$t('view.operativos.seOOB.form.latitud.label')"
                        :error-messages="getFirstErrorDescription($v.seOOB.latitud)"
                        maxlength="20"
                        :disabled="view.action.submit.busy"
                        onkeypress="return /^[0-9.0-9]*$/.test(event.key);" />
                    </v-flex>

                    <!-- Longitud -->
                    <v-flex xs12 md4>
                      <v-text-field
                        v-model.trim="$v.seOOB.longitud.$model"
                        :label="$t('view.operativos.seOOB.form.longitud.label')"
                        :error-messages="getFirstErrorDescription($v.seOOB.longitud)"
                        maxlength="20"
                        :disabled="view.action.submit.busy"
                        onkeypress="return /^[0-9.0-9]*$/.test(event.key);" />
                    </v-flex>

                    <!-- getRelevancia -->
                    <v-flex xs12 md4>
                      <v-text-field
                        v-model.number="$v.seOOB.geoRelevancia.$model"
                        :label="$t('view.operativos.se.form.geoRelevancia.label')"
                        type="number"
                        step="0.01"
                        :rules="rules.geoRelevancia" />
                    </v-flex>

                    <!-- Estatus -->
                    <v-flex xs12>
                      <label for="status" class="v-label mt-3">{{ $t("view.commons.status") }}</label>
                      <v-switch v-model="seOOB.estatus" input-value="true" color="primary" :disabled="view.action.submit.busy" class="mt-1" />
                    </v-flex>
                  </v-layout>
                </form>
              </v-card-text>
            </v-flex>
          </v-expand-transition>
        </v-card>
      </v-flex>
    </v-layout>

    <gallery ref="gallery" :se-o-o-b="seOOB" @removePhoto="removePhoto" />

    <v-layout align-center column class="fab-container">
      <v-btn
        v-show="seOOB.clave && $userPermission.hasPermission('ROLE_ACCESO_AUDITORIA')"
        id="btnaudit"
        fab
        small
        color="primary"
        class="btn_tippy"
        elevation="0"
        :title="$t('view.commons.audit')"
        :loading="view.action.submit.busy"
        @click="audit()">
        <v-icon small>storage</v-icon>
      </v-btn>

      <v-btn id="btnclear" fab small color="primary" class="btn_tippy" elevation="0" :title="$t('view.commons.cancel')" :loading="view.action.submit.busy" @click="clear()">
        <v-icon small>fa-eraser</v-icon>
      </v-btn>

      <v-btn
        v-show="$userPermission.hasPermission('ROLE_MODIFICAR_OP')"
        id="btnsubmit"
        fab
        small
        color="primary"
        class="btn_tippy"
        elevation="0"
        :title="view.elem.button.submit.title.current"
        :loading="view.action.submit.busy"
        :disabled="form.$state.isDisableButtonSubmit()"
        @click="submit()">
        <v-icon small>{{ view.elem.button.submit.class.current }}</v-icon>
      </v-btn>
    </v-layout>

    <auditoria ref="auditModal" />
  </v-container>
</template>
<script>
import seOOBStates from "@/views/operativos/seOOB/seOOB-state"; /** *******************************/
import seOobAPI from "@/services/operativos/seOOB"; /** *******************************/
import DataTable from "@/views/operativos/seOOB/DataTable"; /** *******************************/
import Gallery from "@/views/operativos/seOOB/Gallery"; /** *******************************/
import Auditoria from "@/components/auditoria/Auditoria"; /** *******************************/
import { EventBus } from "@/events/event-bus";
import * as events from "@/constants/event-names";
import { required, email } from "vuelidate/lib/validators";
import { cuit, fixMigImp } from "@/helpers/vuelidate/validators";
import { allValidatorMethods } from "@/helpers/vuelidate";
import { handleResponse } from "@/helpers/http-response-handler";
import { scrollToForm } from "@/helpers/form-scroll-to";
import { submit } from "@/constants/buttons";
import tippy from "tippy.js";

const action = { submit: { busy: false } };

const select = {
  provincia: {
    completeList: []
    , filteredList: []
    , disabled: false
    , search: ""
  }
  , localidad: {
    completeList: []
    , filteredList: []
    , disabled: false
    , search: ""
  }
};

export default {
  name: "SeOOBModule"
  , components: {
    DataTable
    , Gallery
    , Auditoria
  }
  , data() {
    return {
      seOOB: undefined
      , refreshkey: 0
      , form: new Object()
      , view: {
        title: this.$t("view.operativos.seOOB.title")
        , action
        , elem: {
          button: { submit }
          , select
          , showForm: true
        }
      }
      , rules: { geoRelevancia: [(v) => !!v || this.$t("view.operativos.seOOB.rules.requerido.text"), (v) => (v >= 0 && v <= 1) || this.$t("view.operativos.seOOB.rules.geoRelevancia.text")] }
      , check: true
    };
  }
  , head: {
    title: function () {
      return {
        inner: this.view.title
        , separator: "|"
        , complement: this.$t("view.commons.system")
      };
    }
  }
  , created() {
    this.form = new seOOBStates(this);
    this.form.$setState("initial");
  }
  , updated() {
    this.$nextTick(function () {
      tippy(".btn_tippy", { arrow: true, arrowType: "round", animation: "scale" });
    });
  }
  , methods: {
    ...allValidatorMethods
    , async submit() {
      try {
        const respuesta = await this.form.$state.submit(this.seOOB);
        if (handleResponse(respuesta, this.$t("view.operativos.seOOB.errors"))) {
          this.form.$setState("editing", respuesta.data.results.seOOB);
        }
      } catch (error) {
        handleResponse(error, this.$t("view.operativos.seOOB.errors"));
      }
    }
    , async load(clave) {
      try {
        const response = await seOobAPI.get(clave);
        const { data: { results: { seOOB } } } = response;
        if (seOOB.provincia) await this.form.$state.loadSelectLocalidad(seOOB.provincia);
        this.form.$setState("editing", seOOB);
      } catch (error) {
        console.log(error);
      }
    }
    , async clear() {
      await this.form.$state.askForClear();
      setTimeout(() => document.body.click(), 300);
    }
    , async audit(clave = this.seOOB.clave, dataDescripcion = this.seOOB.nombre) {
      this.$refs.auditModal.loadAudit(clave, "TSeOOB", dataDescripcion, this.view.title);
    }
    , executeValidators() {
      if (!this.isAllValid(this.$v)) {
        EventBus.$emit(events.SHOW_TOASTER_MESSAGE, "error", "VL0000", this.$t("errors.validof"));
        scrollToForm(this);
      }
    }
    , async clearLocalization() {
      this.seOOB.longitud = "";
      this.seOOB.latitud = "";
      this.seOOB.geoRelevancia = null;
    }
    , removePhoto(photos) {
      this.seOOB.photos = photos;
    }
  }
  , validations: {
    seOOB: {
      nombre: {
        required
        , fixMigImp: fixMigImp()
      }
      , nombrePersonaContacto: {
        required
        , fixMigImp: fixMigImp()
      }
      , cuit: { cuit: cuit() }
      , direccion: { fixMigImp: fixMigImp() }
      , altura: { fixMigImp: fixMigImp() }
      , provincia: {}
      , localidad: {}
      , referencia: {}
      , cp: {}
      , email: { email }
      , telefono: {}
      , latitud: {}
      , longitud: {}
      , geoRelevancia: {}
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.seOOB .fab-container {
  position: fixed;
  bottom: 90px;
  right: 20px;
  z-index: 1;
}
.seOOB .fab-container .v-btn {
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/operativos/seOOB/SeOOB.vue